import { css } from "@emotion/react"

export const installation = css`
  opacity: 0;
  transform: translateX(calc(10rem * var(--dir)));

  transition: transform 360ms calc(160ms * var(--index)), opacity 360ms calc(160ms * var(--index));

  .show & {
    transform: translateX(0);
    opacity: 1;
  }

  html.prefers-reduced-motion & {
    transition: unset;
  }
  @media (prefers-reduced-motion) {
    transition: unset;
  }
`
